<template>
  <el-dialog :title="title" :visible.sync="visible" width="60%" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="auto">
      <!-- 第一行 -->
      <el-row>
        <!-- <el-col :span="8">
          <el-form-item label="所属项目类别" prop="projectCategory">
            <el-input v-model="form.projectCategory" placeholder="请输入所属项目类别" />
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="仪器编号" prop="eqptNum">
            <el-input v-model="form.eqptNum" placeholder="请输入管理编号" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仪器类型" prop="eqptType">
            <el-select v-model="form.eqptType" placeholder="请选择仪器类型" style="width: 100%;">
              <el-option label="检测仪器" value="检测仪器" />
              <el-option label="办公仪器" value="办公仪器" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="仪器名称" prop="eqptName">
            <el-input v-model="form.eqptName" placeholder="请输入仪器名称" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检定/校准周期" prop="eqptVerificationCycle">
            <el-input v-model="form.eqptVerificationCycle" placeholder="请输入检定/校准周期" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="型号规格" prop="eqptSpecification">
            <el-input v-model="form.eqptSpecification" placeholder="请输入型号规格" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第三行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="生产厂家" prop="eqptManufacturer">
            <el-input v-model="form.eqptManufacturer" placeholder="请输入生产厂家" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="保管人" prop="eqptCustodian">
            <el-input v-model="form.eqptCustodian" placeholder="请输入保管人" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="现状" prop="eqptSituation">
            <el-select v-model="form.eqptSituation" placeholder="请选择现状" style="width: 100%;" @change="handleSituationChange">
              <el-option label="完好" value="完好" />
              <el-option label="准用" value="准用" />
              <el-option label="降级使用" value="降级使用" />
              <el-option label="报修" value="报修" />
              <el-option label="待报废" value="待报废" />
              <el-option label="报废" value="报废" />
              <el-option label="外借" value="外借" />
              <el-option label="停用" value="停用" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第四行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="使用科室" prop="eqptDepartment">
            <el-input v-model="form.eqptDepartment" placeholder="请输入使用科室" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="测量范围" prop="eqptMeasuringRange">
            <el-input v-model="form.eqptMeasuringRange" placeholder="请输入测量范围" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="精度等级" prop="eqptPrecision">
            <el-input v-model="form.eqptPrecision" placeholder="请输入精度等级" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第五行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="出厂编号" prop="eqptFactoryNumber">
            <el-input v-model="form.eqptFactoryNumber" placeholder="请输入出厂编号" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报废人" prop="scrappedBy">
            <el-input v-model="form.scrappedBy" placeholder="请输入报废人" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报废日期" prop="scrappedDate">
            <el-date-picker v-model="form.scrappedDate" type="date" placeholder="选择报废日期" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第六行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="量值溯源方式" prop="sourceType">
            <el-input v-model="form.sourceType" placeholder="请输入量值溯源方式" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="购置日期" prop="eqptPurchaseDate">
            <el-date-picker v-model="form.eqptPurchaseDate" type="date" placeholder="选择购置日期" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="配件数量" prop="eqptAccessoriesQty">
            <el-input v-model="form.eqptAccessoriesQty" placeholder="请输入配件数量" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第七行 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="验收日期" prop="eqptAcceptanceDate">
            <el-date-picker v-model="form.eqptAcceptanceDate" type="date" placeholder="选择验收日期" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启用日期" prop="eqptEnabledDate">
            <el-date-picker v-model="form.eqptEnabledDate" type="date" placeholder="选择启用日期" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="放置地点" prop="eqptPlacement">
            <el-input v-model="form.eqptPlacement" placeholder="请输入放置地点" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 新增部分：校验相关字段 -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="校验类型" prop="eqptVerificationType">
            <el-select v-model="form.eqptVerificationType" placeholder="请选择校验类型" style="width: 100%;" :disabled="title === '修改仪器'">
              <el-option label="校准" value="校准" />
              <el-option label="检定" value="检定" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="校准方式" prop="eqptVerificationWay">
            <el-select v-model="form.eqptVerificationWay" placeholder="请选择校准方式" style="width: 100%;">
              <el-option label="送检" value="送检" />
              <el-option label="现场" value="现场" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="校准/检定单位" prop="eqptVerificationUnit">
            <el-input v-model="form.eqptVerificationUnit" placeholder="请输入校准/检定单位" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="有效期至" prop="eqptVerificationValidity">
            <el-date-picker v-model="form.eqptVerificationValidity" type="date" placeholder="选择有效期至" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="title === '修改仪器'" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检定/校准日期" prop="eqptVerificationDate">
            <el-date-picker v-model="form.eqptVerificationDate" type="date" placeholder="选择检定/校准日期" value-format="yyyy-MM-dd" style="width: 100%;" :disabled="title === '修改仪器'" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单价" prop="unitPrice">
            <el-input v-model="form.unitPrice" placeholder="请输入单价" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="检定/校准证书编号" prop="certificateNo">
            <el-input v-model="form.certificateNo" placeholder="请输入证书编号" :disabled="title === '修改仪器'" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 文件上传部分 -->
      <el-row>
        <el-col :span="10">
          <el-form-item label="单价凭证">
            <el-upload class="upload-demo" action="#" :auto-upload="false" :limit="5" :file-list="priceFileList" :on-change="handlePriceFileChange" :on-remove="handlePriceFileRemove"
                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" :on-preview="handlePriceFilePreview" multiple>
              <el-button size="small" type="primary">上传单价凭证</el-button>
              <div slot="tip" class="el-upload__tip">支持pdf/jpg/png/doc/docx格式，可上传多个文件</div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 备注 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="eqptRemark">
            <el-input type="textarea" v-model="form.eqptRemark" placeholder="请输入备注" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">{{ title === '修改仪器' ? '修 改' : '确 定' }}</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!-- 文件预览对话框 -->
    <el-dialog title="文件预览" :visible.sync="previewDialogVisible" append-to-body width="70%">
      <div v-if="previewFile">
        <div class="file-preview-header">
          <h3>{{ previewFile.name || '未知文件' }}</h3>
          <p>文件类型: {{ getFileTypeFromName(previewFile.name || '').toUpperCase() }}</p>
        </div>

        <!-- 预览区域 -->
        <div class="file-preview-container">
          <!-- PDF预览 -->
          <iframe v-if="isPdfFile(previewFile)" :src="previewUrl" class="pdf-preview"></iframe>

          <!-- 图片预览 -->
          <img v-else-if="isImageFile(previewFile)" :src="previewUrl" class="image-preview" />

          <!-- 其他文件类型 -->
          <div v-else class="no-preview">
            <p>此文件类型不支持在线预览</p>
            <p>Word、Excel等Office文件需要专用软件打开</p>
            <p>请点击下方按钮下载后查看</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadPreviewFile" type="primary" v-if="previewFile">下载文件</el-button>
        <el-button @click="previewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { queryEqptDetail, saveEqpt, updateEqpt } from '@/api/contract/contract'

export default {
  name: "AddAndEdit",
  data () {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      visible: false,
      // 单价上传文件列表
      priceFileList: [],
      // 新上传的文件列表
      newFiles: [],
      // 存储所有上传文件
      uploadFiles: [],
      // 文件预览相关
      previewDialogVisible: false,
      previewFile: null,
      previewUrl: '',
      // 表单参数
      form: {
        id: undefined,
        projectCategory: undefined,
        eqptNum: undefined,
        eqptName: undefined,
        eqptType: undefined,
        eqptDepartment: undefined,
        eqptPurchaseDate: undefined,
        eqptSituation: "",
        unitPrice: undefined,
        eqptCustodian: undefined,
        eqptRemark: undefined,
        // 新增报废相关字段
        scrappedBy: undefined,
        scrappedDate: undefined,
        // 文件相关字段
        priceFiles: [], // 修改为数组，存储多个文件
        // 补充完整报废相关字段
        eqptSpecification: undefined,
        eqptMeasuringRange: undefined,
        eqptPrecision: undefined,
        eqptFactoryNumber: undefined,
        eqptManufacturer: undefined,
        eqptVerificationType: undefined,
        eqptVerificationWay: undefined,
        eqptVerificationUnit: undefined,
        eqptVerificationValidity: undefined,
        eqptVerificationDate: undefined,
        eqptPlacement: undefined,
        eqptVerificationCycle: undefined,
        eqptAccessoriesQty: undefined,
        eqptAcceptanceDate: undefined,
        eqptEnabledDate: undefined,
        sourceType: undefined,
        certificateNo: undefined
      },
      // 表单校准
      rules: {
        projectCategory: [
          { required: true, message: '请输入所属项目类别', trigger: 'blur' }
        ],
        eqptType: [
          { required: true, message: '请选择仪器类型', trigger: 'change' }
        ],
        eqptNum: [
          { required: true, message: '请输入仪器编号', trigger: 'blur' }
        ],
        eqptName: [
          { required: true, message: '请输入仪器名称', trigger: 'blur' }
        ],
        eqptSpecification: [
          { required: true, message: '请输入型号规格', trigger: 'blur' }
        ],
        // eqptMeasuringRange: [
        //   { required: true, message: '请输入测量范围', trigger: 'blur' }
        // ],
        // eqptPrecision: [
        //   { required: true, message: '请输入精度等级', trigger: 'blur' }
        // ],
        eqptFactoryNumber: [
          { required: true, message: '请输入出厂编号', trigger: 'blur' }
        ],
        eqptManufacturer: [
          { required: true, message: '请输入生产厂家', trigger: 'blur' }
        ],
        eqptCustodian: [
          { required: true, message: '请输入保管人', trigger: 'blur' }
        ],
        eqptSituation: [
          { required: true, message: '请输入现状', trigger: 'blur' }
        ],
        eqptVerificationType: [
          { required: true, message: '请输入校验类型', trigger: 'blur' }
        ],
        eqptVerificationWay: [
          { required: true, message: '请输入校准方式', trigger: 'blur' }
        ],
        eqptVerificationUnit: [
          { required: true, message: '请输入校准/检定单位', trigger: 'blur' }
        ],
        // eqptDepartment: [
        //   { required: true, message: '请输入使用科室', trigger: 'blur' }
        // ],
        // eqptPlacement: [
        //   { required: true, message: '请输入放置地点', trigger: 'blur' }
        // ],
        eqptRemark: [
          // { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        eqptVerificationCycle: [
          { required: true, message: '请输入检定/校准周期', trigger: 'blur' },
          { pattern: /^[0-9]+(\.[0-9]+)?$/, message: '只能输入数字,可以包含小数点', trigger: 'blur' }
        ],
        // unitPrice: [
        //   { required: true, message: '请输入单价', trigger: 'blur' },
        //   { pattern: /^\d+(\.\d{1,2})?$/, message: '只能输入数字且最多保留两位小数', trigger: 'blur' }
        // ],
        // 报废相关验证规则
        // scrappedBy: [
        //   { required: true, message: '请输入报废人', trigger: 'blur' }
        // ],
        // scrappedDate: [
        //   { required: true, message: '请选择报废日期', trigger: 'blur' }
        // ]
      }
    };
  },
  created () {

  },
  mounted () {
    console.log('AddAndEdit组件已挂载，事件绑定检查');
    // 检查事件绑定，触发一个测试事件
    this.$emit('test', 'test-event');
  },
  methods: {

    // 取消按钮
    cancel () {
      this.visible = false;
      this.reset();
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        projectCategory: undefined,
        eqptNum: undefined,
        eqptName: undefined,
        eqptType: undefined,
        eqptDepartment: undefined,
        eqptPurchaseDate: undefined,
        eqptSituation: "",
        unitPrice: undefined,
        eqptCustodian: undefined,
        eqptRemark: undefined,
        // 重置报废相关字段
        scrappedBy: undefined,
        scrappedDate: undefined,
        // 重置文件相关字段
        priceFiles: [], // 修改为数组
        // 补充完整报废相关字段
        eqptSpecification: undefined,
        eqptMeasuringRange: undefined,
        eqptPrecision: undefined,
        eqptFactoryNumber: undefined,
        eqptManufacturer: undefined,
        eqptVerificationType: undefined,
        eqptVerificationWay: undefined,
        eqptVerificationUnit: undefined,
        eqptVerificationValidity: undefined,
        eqptVerificationDate: undefined,
        eqptPlacement: undefined,
        eqptVerificationCycle: undefined,
        eqptAccessoriesQty: undefined,
        eqptAcceptanceDate: undefined,
        eqptEnabledDate: undefined,
        sourceType: undefined,
        certificateNo: undefined
      };
      // 清空文件列表
      this.priceFileList = [];
      // 如果表单引用存在,则重置表单所有字段为初始值
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset();
      this.visible = true;
      this.title = "添加仪器";
      // 设置默认值
      this.form.eqptSituation = "完好";
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset();
      this.visible = true;
      this.title = "修改仪器";

      // 调用API获取仪器详情
      queryEqptDetail(row.eqptNum).then((res) => {
        if (res.retCode === "ok") {
          // 处理后台返回的数据 - 新格式：数据在additionalData字段中
          const data = res.additionalData || {};

          // 将后台数据合并到表单中
          this.form = Object.assign({}, this.form, data);
          this.form.oldEqptVerificationDate = row.eqptVerificationDate;

          console.log('获取仪器详情:', this.form);
          console.log('仪器状态:', this.form.eqptSituation);

          // 如果设备状态为报废，确保报废相关字段有初始值
          if (this.form.eqptSituation === '报废') {
            console.log('报废状态处理:', this.form.scrappedBy, this.form.scrappedDate);

            this.form.scrappedBy = this.form.scrappedBy || '';
            this.form.scrappedDate = this.form.scrappedDate || '';

            console.log('设置后:', this.form.scrappedBy, this.form.scrappedDate);
          }

          // 清空上传文件列表
          this.uploadFiles = [];
          this.priceFileList = [];

          // 处理服务器返回的文件列表
          if (data.files && Array.isArray(data.files)) {
            console.log('服务器返回的文件列表:', data.files);

            // 遍历文件列表，根据文件名判断类型
            data.files.forEach(file => {
              // 创建文件对象，保存服务器返回的信息
              const fileObject = {
                ...file,
                name: file.fileName || '未知文件',
                url: file.loadFileUrl || '',
                serverFile: true,
                fileId: file.id,
                filePath: file.filePath,
                serverNum: file.serverNum,
                fileType: file.fileType
              };

              // 判断是否为单价文件
              // if (file.fileName && file.fileName.indexOf('单价文件') !== -1) {
              fileObject.isPriceFile = true;
              this.priceFileList.push(fileObject); // 改为push，支持多个文件
              // }

              // 加入到上传文件列表
              this.uploadFiles.push(fileObject);
            });
          }

          // 强制更新视图
          this.$forceUpdate();
        } else {
          // 如果API调用失败，使用传入的行数据作为备用
          console.warn('获取仪器详情失败，使用传入数据:', res.retCode);
          this.form = Object.assign({}, this.form, row);

          // 如果设备状态为报废，确保报废相关字段有初始值
          if (this.form.eqptSituation === '报废') {
            this.form.scrappedBy = this.form.scrappedBy || '';
            this.form.scrappedDate = this.form.scrappedDate || '';
          }
        }
      }).catch(error => {
        console.error('获取仪器详情出错:', error);
        // 如果API调用出错，使用传入的行数据作为备用
        this.form = Object.assign({}, this.form, row);

        // 如果设备状态为报废，确保报废相关字段有初始值
        if (this.form.eqptSituation === '报废') {
          this.form.scrappedBy = this.form.scrappedBy || '';
          this.form.scrappedDate = this.form.scrappedDate || '';
        }
      });
    },
    /** 提交按钮 */
    submitForm () {
      if (!this.$refs.form) {
        return;
      }

      // 检查如果是报废状态，报废人和报废日期必须填写
      if (this.form.eqptSituation === '报废') {
        if (!this.form.scrappedBy || this.form.scrappedBy.trim() === '') {
          this.$message.error('请填写报废人');
          return;
        }
        if (!this.form.scrappedDate) {
          this.$message.error('请选择报废日期');
          return;
        }
      }

      this.$refs.form.validate(valid => {
        if (valid) {
          // 创建FormData对象，用于上传文件
          let formData = new FormData();
          // 筛选出服务器文件并添加到form.files
          // 删除form中的files字段
          delete this.form.files;
          const serverFiles = this.uploadFiles.filter(file => file.serverFile === true);
          this.form.files = serverFiles;
          // 将表单数据转为JSON字符串添加到FormData
          formData.append('dto', JSON.stringify(this.form));

          // 区分新增和修改的处理逻辑
          if (this.title === "添加仪器") {
            // 新增模式：将所有文件作为files参数上传
            this.uploadFiles.forEach(file => {
              if (file.raw && !file.serverFile) {
                formData.append('files', file.raw);
              }
            });

            // 调用添加仪器API
            saveEqpt(formData).then(response => {
              if (response.retCode === 'ok') {  // 添加响应状态判断
                this.$message.success("新增成功");
                this.visible = false;
                this.reset(); // 重置表单数据
                // 清空上传文件缓存
                this.uploadFiles = [];
                this.newFiles = [];
                formData = null; // 释放formData
                this.$emit("refresh");  // 确保这行代码被执行
              } else {
                console.error('新增仪器失败:', response.msg);
                this.$message.error(response.msg || "新增失败");
              }
            }).catch(error => {
              console.error('新增失败:', error);
              this.$message.error("新增失败");
            });
          } else {
            // 修改模式：处理文件
            // 1. 筛选出服务器上已有的文件（如果还存在的话）
            const serverFiles = this.uploadFiles.filter(file => file.serverFile === true);

            // 2. 检查单价文件是否已被删除
            const hasPriceFiles = this.priceFileList.length > 0;

            // 3. 如果已删除所有文件，确保files字段为空数组
            if (serverFiles.length === 0) {
              // 用户已删除所有服务器文件，设置空数组
              this.form.files = [];
            } else {
              // 仍有服务器文件，正常设置
              this.form.files = serverFiles;
            }

            console.log('修改仪器 - 服务器文件状态:', {
              '服务器文件数量': serverFiles.length,
              '单价文件是否存在': hasPriceFiles,
              '提交的files': this.form.files
            });

            // 4. 添加新上传的文件
            const newUploadFiles = this.uploadFiles.filter(file => !file.serverFile && file.raw);
            console.log('新上传文件数量:', newUploadFiles.length);

            newUploadFiles.forEach(file => {
              formData.append('newFiles', file.raw);
            });

            // 调用修改仪器API
            updateEqpt(formData).then(response => {
              if (response.retCode === 'ok') {  // 添加响应状态判断，使用全等判断
                this.$message.success("修改成功");
                this.visible = false;
                this.reset(); // 重置表单数据
                // 清空上传文件缓存
                this.uploadFiles = [];
                this.newFiles = [];
                formData = null; // 释放formData
                console.log('发送refresh事件'); // 调试日志
                this.$emit("refresh");  // 确保这行代码被执行
              } else {
                // 处理非200响应
                console.error('修改仪器失败:', response.msg);
                this.$message.error(response.msg || "修改失败");
              }
            }).catch(error => {
              console.error('修改仪器请求失败:', error);
              this.$message.error("修改失败: " + (error.message || '未知错误'));
            });
          }
        }
      });
    },
    // 处理现状选择变化
    handleSituationChange (value) {
      console.log('仪器状态变更为:', value);
      // 如果选择报废，确保报废相关字段有初始值
      if (value === '报废') {
        this.form.scrappedBy = this.form.scrappedBy || '';
        this.form.scrappedDate = this.form.scrappedDate || '';
      } else {
        // 如果不是报废状态，清空报废相关字段
        this.form.scrappedBy = undefined;
        this.form.scrappedDate = undefined;
      }

      // 强制更新视图
      this.$forceUpdate();
    },
    // 处理单价文件变更
    handlePriceFileChange (file, fileList) {
      console.log('价格文件变更:', file, fileList);
      this.priceFileList = fileList;
      if (file.raw) {
        // 验证文件类型
        const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
          .includes(file.raw.type);
        if (!isValidType) {
          this.$message.error('只能上传PDF/JPG/PNG/DOC/DOCX格式的文件!');
          // 从文件列表中移除无效文件
          this.priceFileList = this.priceFileList.filter(f => f.uid !== file.uid);
          return false;
        }

        // 验证文件大小（不超过5MB）
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过5MB!');
          // 从文件列表中移除过大文件
          this.priceFileList = this.priceFileList.filter(f => f.uid !== file.uid);
          return false;
        }

        // 设置自定义文件名
        const newFileName = file.name;

        // 创建带有自定义文件名的文件对象
        const customFile = new File([file.raw], newFileName, { type: file.raw.type });

        // 标记为新文件
        if (file.status === 'ready') {
          file.isNewFile = true;
        }

        // 更新上传文件列表 - 不再过滤掉之前的价格文件
        this.uploadFiles.push({
          ...file,
          raw: customFile,
          isPriceFile: true,
          isNewFile: true,
          customFileName: newFileName
        });

        // 将文件添加到form.priceFiles数组中
        if (!this.form.priceFiles) {
          this.form.priceFiles = [];
        }
        this.form.priceFiles.push(customFile);
      }
      return true;
    },

    // 移除单价文件
    handlePriceFileRemove (file) {
      console.log('移除价格文件:', file);

      // 从价格文件列表中移除
      this.priceFileList = this.priceFileList.filter(f => f.uid !== file.uid);

      // 从上传文件列表中移除
      const removedIndex = this.uploadFiles.findIndex(f => f.uid === file.uid);
      if (removedIndex !== -1) {
        this.uploadFiles.splice(removedIndex, 1);
      }

      // 从form.priceFiles数组中移除
      if (this.form.priceFiles && Array.isArray(this.form.priceFiles)) {
        // 由于无法直接比较File对象，我们使用索引来匹配
        // 假设uploadFiles中的索引与priceFiles中的索引相对应
        if (removedIndex !== -1 && removedIndex < this.form.priceFiles.length) {
          this.form.priceFiles.splice(removedIndex, 1);
        }
      }

      // 如果是移除服务器文件，确保form.files中不包含此文件
      if (file.serverFile) {
        console.log('移除服务器单价文件');

        // 如果form.files存在，从中过滤掉被删除的文件
        if (this.form.files && Array.isArray(this.form.files)) {
          this.form.files = this.form.files.filter(f => {
            if (f.id === file.fileId || f.id === file.id) {
              console.log('从files中移除文件:', f);
              return false;
            }
            return true;
          });
        }
      }

      console.log('移除文件后状态:', {
        '文件列表': this.uploadFiles,
        'priceFiles数组': this.form.priceFiles,
        'files字段': this.form.files
      });
    },

    // 预览单价文件
    handlePriceFilePreview (file) {
      console.log('预览文件:', file);

      let url = '';
      if (file.url) {
        url = file.url;
      } else if (file.raw) {
        url = URL.createObjectURL(file.raw);
      }

      if (!url) {
        this.$message.error('无法预览此文件');
        return;
      }

      // 设置预览文件和URL
      this.previewFile = file;
      this.previewUrl = url;

      // 显示预览对话框
      this.previewDialogVisible = true;
    },

    // 下载预览文件
    downloadPreviewFile () {
      if (!this.previewFile || !this.previewUrl) {
        return;
      }

      try {
        // 创建一个临时链接用于下载
        const link = document.createElement('a');
        link.href = this.previewUrl;
        link.setAttribute('download', this.previewFile.name || '下载文件');
        // 确保链接不在当前页面打开
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        document.body.appendChild(link);

        // 对于PDF和图片文件，我们需要特殊处理以确保下载而不是预览
        const fileType = this.getFileTypeFromName(this.previewFile.name || '');

        // 如果是服务器文件且有原始URL，我们需要使用fetch API下载
        if (this.previewFile.url && (this.isPdfFile(this.previewFile) || this.isImageFile(this.previewFile))) {
          // 使用fetch获取文件内容并强制下载
          fetch(this.previewUrl)
            .then(response => response.blob())
            .then(blob => {
              const blobUrl = window.URL.createObjectURL(blob);
              const downloadLink = document.createElement('a');
              downloadLink.href = blobUrl;
              downloadLink.setAttribute('download', this.previewFile.name || '下载文件');
              document.body.appendChild(downloadLink);
              downloadLink.click();
              // 清理
              setTimeout(() => {
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(blobUrl);
              }, 100);
            })
            .catch(err => {
              console.error('下载文件失败:', err);
              this.$message.error('下载文件失败，请重试');
              // 如果fetch失败，回退到普通下载方式
              link.click();
            });
        } else {
          // 对于本地文件或其他类型，使用普通下载方式
          link.click();
        }

        // 清理DOM
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
      } catch (error) {
        console.error('下载文件出错:', error);
        this.$message.error('下载文件失败，请重试');

        // 最后的备用方案：在新窗口打开文件
        window.open(this.previewUrl, '_blank');
      }
    },

    // 判断是否为PDF文件
    isPdfFile (file) {
      if (!file || !file.name) return false;
      const fileType = this.getFileTypeFromName(file.name);
      return fileType.toLowerCase() === 'pdf';
    },

    // 判断是否为图片文件
    isImageFile (file) {
      if (!file || !file.name) return false;
      const fileType = this.getFileTypeFromName(file.name);
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileType.toLowerCase());
    },

    // 从文件名获取文件类型
    getFileTypeFromName (filename) {
      if (!filename) return '';
      const parts = filename.split('.');
      return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
    },

    // 从URL中提取文件名
    getFileNameFromUrl (url) {
      if (!url) return '';
      // 获取URL中的文件名部分
      const parts = url.split('/');
      return parts[parts.length - 1] || '附件';
    },

    // 从URL提取文件扩展名
    getFileExtFromUrl (url) {
      if (!url) return '';
      const filename = this.getFileNameFromUrl(url);
      const parts = filename.split('.');
      return parts.length > 1 ? '.' + parts[parts.length - 1] : '';
    },
  }
};
</script>

<style scoped>
.input-with-upload {
  position: relative;
}

.input-with-upload .el-input {
  width: 100%;
  margin-bottom: 8px;
}

.upload-button {
  margin-top: 5px;
}

.el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: 0;
}

.debug-info {
  padding: 5px;
  background-color: #f9f9f9;
  border: 1px dashed #ddd;
  font-size: 12px;
  color: #409eff;
}

.debug-info p {
  margin: 2px 0;
}

.file-info {
  padding: 8px;
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  background-color: #f5f7fa;
  margin-top: 28px;
}

.file-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #606266;
  word-break: break-all;
}

.upload-demo {
  width: 100%;
}

/* 文件预览样式 */
.file-preview-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.file-preview-header h3 {
  margin: 0 0 10px 0;
  font-size: 18px;
}

.file-preview-header p {
  margin: 0;
  color: #909399;
}

.file-preview-container {
  min-height: 400px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.pdf-preview,
.image-preview {
  width: 100%;
  height: 500px;
  object-fit: contain;
}

.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}
</style>